<template>
  <div class="ml-3">
    <v-card class="pa-0">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select
              v-bind:label="$t('Group')"
              v-model="filter.group"
              :items="groupList"
              item-text="text"
              item-value="id"
              @change="updateGrid"
              clearable
            ></v-select>
          </v-col>
          <v-col>
            <BaseDatePicker
              v-model="filter.from"
              :label="$t('From')"
              clearable
              @change="updateGrid"
            />
          </v-col>
          <v-col>
            <BaseDatePicker
              v-model="filter.to"
              :label="$t('To')"
              clearable
              @change="updateGrid"
            />
          </v-col>
          <v-col>
            <v-autocomplete
              v-bind:label="$t('User')"
              v-model="filter.userIds"
              :items="userList"
              item-text="text"
              item-value="id"
              multiple
              @change="updateGrid"
              clearable
            />
          </v-col>
          <v-col>
            <v-autocomplete
              v-bind:label="$t('Type')"
              v-model="filter.typeIds"
              :items="typeList"
              item-text="text"
              item-value="id"
              multiple
              @change="updateGrid"
              clearable
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="pa-0 mt-0">
      <v-card-text class="pt-0 mt-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          :showCommands="false"
          :allowFilter="false"
          :allowGrouping="false"
          :allowExport="false"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AuditService from "@/services/AuditService";
import UserService from "@/services/UserService";
import AuditType from "@/ecm/variables/AuditType.js";

export default {
  data() {
    return {
      title: this.$t("Audits"),
      groupList: [
        { id: "1", text: this.$t("Administration") },
        { id: "2", text: this.$t("Documents") },
        { id: "3", text: this.$t("Searches") },
        { id: "4", text: this.$t("Flows") },
        { id: "5", text: this.$t("Delegations") },
      ],
      userList: [],
      typeList: [],
      filter: {
        group: null,
        from: null,
        to: null,
        userIds: null,
        typeIds: null,
      },
      grid: {
        key: "auditGrid",
        dataSource: AuditService.getGrid(),
        columns: [
          {
            field: "DateTime",
            caption: this.$t("Date"),
            type: "date",
            format: `${this.$store.getters["account/user"].MetricDateFormat} hh:mm`
          },
          {
            field: "Type",
            caption: this.$t("Type"),
            type: "string",
          },
          {
            field: "User",
            caption: this.$t("User"),
            type: "string",
          },
          {
            field: "Description",
            caption: this.$t("Description"),
            type: "string",
          },
        ],
      },
    };
  },
  created() {
    AuditService.getTypes().then((data) => {
      this.typeList = data;
    });
    UserService.getList().then((data) => {
      this.userList = data;
    });
  },
  methods: {
    updateGrid() {
      this.grid.dataSource = AuditService.getGrid(this.getFilter());
      this.filterTypesByGroups();
      this.gridInstance.refresh();
    },
    getFilter() {
      var filter = "";
      if (this.filter.from) filter += `&from=${this.filter.from}`;
      if (this.filter.to) filter += `&to=${this.filter.to}`;
      if (this.filter.group) filter += `&group=${this.filter.group}`;
      if (this.filter.userIds) filter += `&userIds=${this.filter.userIds}`;
      if (this.filter.typeIds) filter += `&typeIds=${this.filter.typeIds}`;

      return filter;
    },
    filterTypesByGroups() {
      AuditService.getTypes().then((data) => {
        this.typeList = data;
        let typesInGroup = this.getTypesOfGroup();

        if (typesInGroup.length != 0) {
          let newTypes = [];
          for (let l = 0; l < this.typeList.length; l++) {
            let id = parseInt(this.typeList[l].id);
            if (typesInGroup.includes(id)) {
              newTypes.push(this.typeList[l]);
            }
          }
          this.typeList = newTypes;
        }
      });
    },
    getTypesOfGroup() {
      switch (this.filter.group) {
        case this.groupList[0].id:
          return [
            AuditType.ADMINISTRATION_DELETE,
            AuditType.ADMINISTRATION_UPDATE,
            AuditType.ADMINISTRATION_CREATE,
          ];
        case this.groupList[1].id:
          return [
            AuditType.DOCUMENT_DELETE,
            AuditType.DOCUMENT_INSERT,
            AuditType.DOCUMENT_UPDATE,
            AuditType.DOCUMENT_UPDATE_ATTACHMENT,
            AuditType.DOCUMENT_DELETE_PERMANENTLY,
            AuditType.DOCUMENT_RESTORE,
            AuditType.DOCUMENT_ARCHIVE,
            AuditType.DOCUMENT_DOWNLOAD,
            AuditType.DOCUMENT_DISPLAY,
            AuditType.DOCUMENT_PRINT,
            AuditType.DOCUMENT_AUTO_UPDATE,
            AuditType.DOCUMENT_CONTENT_TYPE_CHANGE,
            AuditType.DOCUMENT_SIGN,
            AuditType.DOCUMENT_SEND_BY_EMAIL,
            AuditType.COMMENT_CREATE,
            AuditType.COMMENT_CREATE_EXTERNAL,
            AuditType.COMMENT_UPDATE,
            AuditType.COMMENT_DELETE,
            AuditType.DOCUMENT_ATTACHMENT_INSERT,
            AuditType.DOCUMENT_ATTACHMENT_UPDATE,
            AuditType.DOCUMENT_ATTACHMENT_DELETE,
            AuditType.DOCUMENT_ATTACHMENT_DISPLAY,
            AuditType.DOCUMENT_ATTACHMENT_DOWNLOAD,
            AuditType.DOCUMENT_DISPLAY_EXTERNAL,
            AuditType.DOCUMENT_SIGN_EXTERNAL,
            AuditType.DOCUMENT_DOWNLOAD_EXTERNAL,
            AuditType.DOCUMENT_VALIDATE_EXTERNAL,
            AuditType.DOCUMENT_REJECT_EXTERNAL,
          ];
        case this.groupList[2].id:
          return [
            AuditType.USER_ADVANCED_SEARCH,
            AuditType.USER_NATURAL_SEARCH,
            AuditType.USER_BASKET_SEARCH,
            AuditType.USER_NOTIFICATION_SEARCH,
          ];
        case this.groupList[3].id:
          return [
            AuditType.FLOW_VALIDATE_ACTION,
            AuditType.FLOW_REFUSE_ACTION,
            AuditType.FLOW_DISTRIBUTE_ACTION,
          ];
        case this.groupList[4].id:
          return [
            AuditType.DELEGATION_SCHEDULED_START,
            AuditType.DELEGATION_SCHEDULED_END,
            AuditType.DELEGATION_MANUAL_START,
            AuditType.DELEGATION_MANUAL_END,
          ];
        default:
          return [];
      }
    },
  },
  computed: {
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
};
</script>
